import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StoresForm from '../../components/blocks/StoreForm';
import { getCartStores } from '../../store/actions/cart';

function StoresFormContainer(props) {
  const { getStores, stores, sendOrder, hasErrors, retailerId, retailerName, isLoading, isAdmin } = props;

  useEffect(() => {
    getStores();
  }, [getStores]);

  return (
    <StoresForm
      stores={stores}
      sendOrder={sendOrder}
      hasErrors={hasErrors}
      retailerId={retailerId}
      retailerName={retailerName}
      isLoading={isLoading}
      isAdmin={isAdmin}
    />
  );
}

const mapStateToProps = (state) => {
  const { stores, isLoadingForm: isLoading } = state.cart;
  const { user, retailerId } = state.role;

  let isAdmin = false;
  let retailerName;

  if (user) {
    const retailerPermission = user.retailers.find(({ id }) => id === retailerId);
    if (retailerPermission) {
      retailerName = retailerPermission.name;
      isAdmin = retailerPermission.administration_permission === 'write' || user.is_super_admin;
    }
  }

  return {
    stores,
    isLoading,
    retailerId,
    retailerName,
    isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStores: () => dispatch(getCartStores()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoresFormContainer);

StoresFormContainer.propTypes = {
  hasErrors: PropTypes.bool,
  retailerId: PropTypes.number,
  retailerName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  getStores: PropTypes.func.isRequired,
  sendOrder: PropTypes.func.isRequired,
};
